<template>
  <div>
    <!-- 列表 -->
    <el-table v-loading="loading" element-loading-text="拼命加载中" stripe :data="tableData" style="width: 100%">
      <el-table-column type="expand">
        <template scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="初始化状态">
              <span>{{ props.row.initialized?"已初始化": '未初始化' }}</span>
            </el-form-item>
            <el-form-item label="使用状态">
              <span>{{ props.row.status=='normal' ? "正常": '禁止使用' }}</span>
            </el-form-item>
            <el-form-item label="类型">
              <span>{{ props.row.type }}</span>
            </el-form-item>
            <el-form-item label="创建时间">
              <span>{{ props.row.createdAt }}</span>
            </el-form-item>
            <el-form-item label="APP ID">
              <span>{{ props.row.app && props.row.app.objectId }}</span>
            </el-form-item>
            <el-form-item label="APP notifyURL">
              <span>{{ props.row.app && props.row.app.notifyURL }}</span>
            </el-form-item>
            <el-form-item label="APP Remark">
              <span>{{ props.row.app && props.row.app.remark }}</span>
            </el-form-item>
            <el-form-item label="simCode">
              <span>{{ props.row.simCo}}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="机柜 ID" prop="objectId" min-width='180'>
      </el-table-column>
      <el-table-column label="机柜状态" prop="online" min-width='110'>
          <template scope="scope">
            <el-tag size="medium" :type="scope.row.online ? 'success' : 'danger' " >{{scope.row.online  ? '在线': '离线'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="版本号" prop="version" min-width='80'>
      </el-table-column>
      <el-table-column label="版本类型" prop="boardType" min-width='120'>
      </el-table-column>
      <el-table-column label="mac地址" prop="mac" min-width='180'>
      </el-table-column>
      <el-table-column label="从设备" prop="slave.mac" min-width='180'>
      </el-table-column>
      <el-table-column label="app名称" prop="app.name" min-width='180'>
      </el-table-column>
      <el-table-column label="备注" prop="remark" min-width='180'>
      </el-table-column>
      <el-table-column label="操作" fixed='right' align='center' width='210'>
        <template scope="scope">
          <el-button size="small" @click="dialogFormVisible2=true, slaveId=scope.row.objectId, cabinet = ''">从设备</el-button>
          <el-button size="small" @click="editOpt(scope.row)">编辑</el-button>
          <el-button size="small" @click="handleDetail(scope.row.objectId, scope.row.sectionCount)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Page :way="ways" @pageNum='pageNum' @pageOne='pageOne'></Page>
    <!-- 弹框 编辑 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="机柜类型" :label-width="formLabelWidth">
          <el-input v-model="form.type" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="form.remark" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="使用状态" :label-width="formLabelWidth">
          <el-select v-model="form.status" placeholder="使用状态">
            <el-option label="正常" value="normal"></el-option>
            <el-option label="停用" value="disabled"></el-option>
            <el-option label="损坏" value="damaged"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="app选择" :label-width="formLabelWidth">
          <el-select v-model="form.appId" placeholder="app">
            <el-option v-for="(item, index) in list" :label="item.name" :key="index" :value="item.objectId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="edit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="备份" :visible.sync="dialogFormVisible2">
      <el-form :model="form">
        <el-form-item label="机柜选择" :label-width="formLabelWidth">
          <el-select v-model="cabinet" placeholder="备份机柜" filterable>
            <el-option v-for="(item, index) in cabinetList" :label="item.mac" :key="index" :value="item.objectId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="edit2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import util from '../../util/util';
import Page from '../../components/Page.vue'
export default {
  components: {
    Page,
  },
  data() {
    return {
      tableData: [],
      loading: true,
      dialogFormVisible: false,
      dialogFormVisible2: false,
      form: {
        objectId: '',
        type: '',
        remark: '',
        status: '',
        appId: ''
      },
      editData: {},
      formLabelWidth: '80px',
      list: [],
      ways: '/cabinets',
      limit: util.limit,
      skip: util.skip,
      cabinet: '',
      cabinetList: [],
      slaveId: '',
    }
  },
  methods: {
    pageNum(msg) {
        this.limit = msg;
        localStorage.setItem('openXiao', JSON.stringify({limit: this.limit}));
        this.getData();
    },
    pageOne(msg) {
        this.skip = msg - 1;
        this.getData();
    },
    getData() {
        this.loading = true;
        axios.get('/cabinets', {
            params: {
                limit: this.limit,
                skip: this.skip * this.limit,
                order: '-createdAt',
                include: 'alave'
            }
        }).then((response) => {
            this.tableData = response.data;
            this.tableData.filter(item => { item.createdAt = util.dateForm(item.createdAt) ; });
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
        })
    },
    getApp() {
      axios.get('/apps').then((response) => {
        this.list = response.data;
      })
    },
    getCabinets() {
        axios.get('/cabinets', {params: {limit:10000, skip:0}}).then((response) => {
             this.cabinetList = response.data;
        })
    },
    // 编辑按钮
    editOpt(row) {
      this.getApp();
      this.dialogFormVisible = true,
      this.editData = row;
      this.editData.app ? this.form.appId = this.editData.app.objectId : this.form.appId = '';
      this.form.type = row.type;
      this.form.remark = row.remark;
      this.form.status = row.status;
    },
    // 查看详情
    handleDetail(row, section) {
      this.$router.push({ path: '/cabinetDetail', query: { cabinetId: row, section: section } })
    },
    // 编辑信息
    edit() {
      this.dialogFormVisible = false;
      axios.put('/cabinets/' + this.editData.objectId, {
        app: {
          __type: 'Pointer',
          className: 'App',
          objectId: this.form.appId
        },
        type: this.form.type,
        remark: this.form.remark,
        status: this.form.status
      }).then((response) => {
        this.getData();
      })
    },
    edit2() {
        this.dialogFormVisible2 = false;
        if(this.cabinet == '') {
            this.$message.error('请选择机柜备份！');
            return;
        }
        axios.put('/cabinets/' + this.slaveId, {
            slave: {
                __type: 'Pointer',
                className: 'Cabinet',
                objectId: this.cabinet
            }
        }).then(res => {
            this.getData();
        })
    }
  },
  mounted() {
      this.getCabinets()
  }

}
</script>
<style scoped>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/cabinet/Cabinet.vue?e4fda84a